__webpack_require__.p = "/kompatech-cp/";